const palette = {
  brand: {
    "100": "#001536",
    "300": "#041F4A",
    "400": "#052962",
    "500": "#0077B6",
    "600": "#506991",
    "800": "#C1D8FC"
  },
  brandAlt: {
    "200": "#F3C100",
    "300": "#FFD900",
    "400": "#FFE500"
  },
  culture: {
    "50": "#2B2625",
    "100": "#3E3323",
    "200": "#574835",
    "300": "#6B5840",
    /** @deprecated Use palette.culture.400 */
    "350": "#866D50",
    "400": "#866D50",
    "450": "#A1845C",
    "500": "#EACCA0",
    "600": "#E7D4B9",
    "700": "#EFE8DD",
    "800": "#FBF6EF"
  },
  error: {
    "400": "#C70000",
    "500": "#FF9081"
  },
  focus: {
    "400": "#0077B6"
  },
  labs: {
    "200": "#0C7A73",
    "300": "#65A897",
    "400": "#69D1CA"
  },
  lifestyle: {
    "100": "#510043",
    "200": "#650054",
    "300": "#7D0068",
    "400": "#BB3B80",
    "450": "#F37ABC",
    "500": "#FFABDB",
    "600": "#FEC8D3",
    "800": "#FEEEF7"
  },
  neutral: {
    "0": "#000000",
    "7": "#121212",
    "10": "#1A1A1A",
    "20": "#333333",
    "38": "#545454",
    "46": "#707070",
    "60": "#999999",
    "73": "#BABABA",
    "86": "#DCDCDC",
    "93": "#EDEDED",
    "97": "#F6F6F6",
    "100": "#FFFFFF"
  },
  news: {
    "100": "#660505",
    "200": "#8B0000",
    "300": "#AB0613",
    "400": "#C70000",
    "500": "#FF5943",
    "550": "#FF9081",
    "600": "#FFBAC8",
    "800": "#FFF4F2"
  },
  opinion: {
    "100": "#672005",
    "200": "#8D2700",
    /** @deprecated Use palette.opinion.400 */
    "300": "#C74600",
    "400": "#C74600",
    "450": "#E05E00",
    "500": "#FF7F0F",
    "550": "#FF9941",
    "600": "#F9B376",
    "800": "#FEF9F5"
  },
  specialReport: {
    "100": "#222527",
    "200": "#303538",
    "300": "#3F464A",
    "400": "#595C5F",
    "450": "#9DA0A2",
    "500": "#ABC2C9",
    "700": "#E4E5E8",
    "800": "#EFF1F2"
  },
  specialReportAlt: {
    "100": "#2B2B2A",
    "200": "#B9300A",
    "300": "#FF663D",
    "700": "#EBE6E1",
    "800": "#F5F0EB"
  },
  sport: {
    "100": "#003C60",
    "200": "#004E7C",
    "300": "#005689",
    "400": "#0077B6",
    "500": "#00B2FF",
    "600": "#90DCFF",
    "800": "#F1F8FC"
  },
  success: {
    "300": "#185E36",
    "400": "#22874D",
    "500": "#58D08B"
  }
};

export { palette };
